export default "__VITE_ASSET__D0pti2cQ__"